import { createReducer } from "@reduxjs/toolkit";
import React, { createContext, useContext, useReducer } from "react";
import { STATUS } from "../constants/status.constant";
import _ from "lodash";

const HardPromotionFormContext = createContext();

const INIT_STATE = {
  id: null,
  loading: false,
  data: {
    id: null,
    code: null,
    name: null,
    start_date: null,
    end_date: null,
    status: STATUS.ACTIVE,
    items: [],
    free: [],
    type: "",
    condition_type: "",
    condition_amount: 1,
    receive_qty: 1,
  },
  modal: {
    name: "",
  },
};

const reducer = createReducer(INIT_STATE, (builder) => {
  builder
    .addCase("LOAD_DATA", (state) => {
      state.loading = true;
    })
    .addCase("LOAD_DATA_SUCCESS", (state, { payload }) => {
      state.loading = false;
      state.id = payload.id;
      state.data = { ...payload };
    })
    .addCase("LOAD_DATA_FAIL", (state) => {
      state.loading = false;
      state.id = null;
      state.data = { ...INIT_STATE.data };
    })
    .addCase("SET_DATA", (state, { payload }) => {
      if (payload.condition_type && payload.condition_type !== "item") {
        // Update State ProductItem
        for (let item of state?.data?.items || []) {
          item.qty = 1;
        }
      }
      state.data = {
        ...state.data,
        ...payload,
      };
    })
    .addCase("ADD_ITEM", (state, { payload }) => {
      const addItems = [...(state.data.items || [])];
      const addFree = [...(state.data.free || [])];

      if (
        payload.type === "items" &&
        !_.find(addItems, (n) => n.product_code === payload.product_code)
      ) {
        addItems.push({
          product_code: payload.product_code,
          product_name: payload.product_name,
          qty: payload.qty || 1,
        });
      } else if (
        payload.type === "free" &&
        !_.find(addFree, (n) => n.product_code === payload.product_code)
      ) {
        addFree.push({
          product_code: payload.product_code,
          product_name: payload.product_name,
          qty: payload.qty || 1,
        });
      }

      state.data.items = addItems;
      state.data.free = addFree;
    })
    .addCase("SET_ITEM", (state, { payload }) => {
      let items = [...(state.data.items || [])];
      let free = [...(state.data.free || [])];
      if (payload.type === "items") {
        const _findIndex = _.findIndex(
          items,
          (n) => n.product_code === payload.product_code,
        );
        if (_findIndex !== -1)
          items[_findIndex] = { ...items[_findIndex], ...payload.value };
      } else if (payload.type === "free") {
        const _findIndex = _.findIndex(
          free,
          (n) => n.product_code === payload.product_code,
        );
        if (_findIndex !== -1)
          free[_findIndex] = { ...free[_findIndex], ...payload.value };
      }

      state.data.items = items;
      state.data.free = free;
    })
    .addCase("DEL_ITEM", (state, { payload }) => {
      let delItems = [...(state.data.items || [])];
      let delFree = [...(state.data.free || [])];

      if (payload.type === "items") {
        delItems = _.filter(
          delItems,
          (n) => n.product_code !== payload.product_code,
        );
      } else if (payload.type === "free") {
        delFree = _.filter(
          delFree,
          (n) => n.product_code !== payload.product_code,
        );
      }

      state.data.items = delItems;
      state.data.free = delFree;
    })
    .addCase("OPEN_MODAL", (state, { payload }) => {
      state.modal = {
        ...payload,
      };
    })
    .addCase("CLOSE_MODAL", (state) => {
      state.modal = {
        ...INIT_STATE.modal,
      };
    })
    .addDefaultCase(() => {});
});

export const useHardPromotionFormMutate = () => {
  const context = useContext(HardPromotionFormContext);
  if (!context)
    throw new Error(
      "Hard Promotion Form Mutate Context must be used within Hard Promotion Mutate Form Provider",
    );
  return context;
};

export const HardPromotionMutateFormProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, INIT_STATE);
  return (
    <HardPromotionFormContext.Provider value={{ state, dispatch }}>
      {children}
    </HardPromotionFormContext.Provider>
  );
};
